import { Component, computed, inject } from '@angular/core';
import { SUPPORT_WSP_DISPLAY, supportWspLink } from '@shared/constants/support';
import { WSP_DISCONNECTED_TEXT, WspStatusService } from '@shared/services/wsp-status.service';

/*
 * Aviso fijo arriba del contenido, en todas las pantallas, mientras el WhatsApp de la administración está desconectado
 * o sin configurar (AF327, ver WspStatusService). No se puede cerrar: desaparece solo cuando vuelve a estar conectado.
 * No se muestra a las cuentas sin suscripción (tienen su mensaje al tocar el botón de la barra superior).
 * Usa los estilos del aviso de "sin mensajes".
 */
@Component({
    selector: 'app-wsp-disconnected-banner',
    standalone: true,
    imports: [],
    templateUrl: './wsp-disconnected-banner.component.html',
    styleUrl: '../no-messages-banner/no-messages-banner.component.scss',
})
export class WspDisconnectedBannerComponent {
    private wspStatus = inject(WspStatusService);

    visible = this.wspStatus.isDisconnected;
    reason = this.wspStatus.reason;
    //con un motivo propio (sin configurar, número no dado de alta) se agrega qué pasa mientras tanto
    extra = computed(() => this.reason() && this.reason() !== WSP_DISCONNECTED_TEXT
        ? 'Mientras tanto, AdminAI no puede recibir ni mandar mensajes. Comunicate con Soporte de AdminAI para conectarlo.'
        : '');
    supportDisplay = SUPPORT_WSP_DISPLAY;
    supportLink = supportWspLink('Hola, mi WhatsApp de AdminAI está desconectado');
}
